import Vue from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './i18n'

i18n.locale = store.state.jezik

Vue.config.productionTip = false

const app = new Vue({
  el: '#app',
  i18n,
  store,
  render: h => h(App)
})
if (module.hot) {
  module.hot.accept(['./locales/en.json', './locales/bs.json'], function () {
    app.$i18n.setLocaleMessage('en', require('./locales/en.json').default)
    app.$i18n.setLocaleMessage('bs', require('./locales/bs.json').default)
  })
}


